import { all, fork } from "redux-saga/effects";
import authSaga from "../features/auth/store/authSaga";
import agentChatSaga from "../features/agentChat/store/agentChatSaga";
import { documentsSaga } from "../features/documents/store/documentsSaga";
import { documentUploadsSaga } from "../features/documentUploads/store/documentUploadsSaga";
import { insightsSaga } from "../features/insights/store/insightsSaga";
import analyticsSaga from "../features/analytics/store/analyticsSaga";
import { propertiesSaga } from "../features/properties/store/propertiesSaga";

export default function* rootSaga() {
  yield all([
    fork(agentChatSaga),
    fork(authSaga),
    fork(documentsSaga),
    fork(documentUploadsSaga),
    fork(insightsSaga),
    fork(analyticsSaga),
    fork(propertiesSaga),
  ]);
}
